/* eslint-disable ddsd */

import React, { useState } from "react";
import cx from "classnames";
import { Link } from "react-router-dom";
import ClickOutside from "../ClickOutside";
import styles from "./Dropdown.module.scss";

export interface DropdownProps {
  className?: string;
  children: React.ReactElement;
  menu: React.ReactNode;
}

interface DropdownStatic {
  List: React.FC;
  Item: React.FC<DropdownItemProps>;
}

const Dropdown: React.FC<DropdownProps> & DropdownStatic = ({ className, children, menu }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <ClickOutside onClickOutside={() => setIsOpen(false)}>
      <div className={cx(styles.dropdown, className)}>
        <div className={styles.toggle}>
          {React.cloneElement(children, {
            onClick: (e: React.MouseEvent) => {
              setIsOpen(!isOpen);
              if (children.props.onClick) {
                children.props.onClick(e);
              }
            },
            onKeyUp: (e: React.KeyboardEvent) => {
              if (children.props.onKeyUp) {
                children.props.onKeyUp(e);
              }
              if (e.key === " " || e.key === "Enter") {
                return;
              }
              if (e.key === "Escape") {
                setIsOpen(false);
                return;
              }
              setIsOpen(!isOpen);
            },
          })}
        </div>
        {isOpen && menu}
      </div>
    </ClickOutside>
  );
};

export const DropdownList: React.FC = ({ children }) => {
  return <ul className={styles.list}>{children}</ul>;
};

Dropdown.List = DropdownList;

interface DropdownItemProps {
  to?: string;
  href?: string;
  onClick?: () => void;
}

export const DropdownItem: React.FC<DropdownItemProps> = ({ children, to, href, onClick }) => {
  let item = null;

  const commonProps = {
    className: styles.item,
    onClick,
  };

  if (to) {
    item = (
      <Link to={to} {...commonProps}>
        {children}
      </Link>
    );
  } else if (href) {
    item = (
      <a href={href} {...commonProps}>
        {children}
      </a>
    );
  } else {
    item = (
      <button type="button" {...commonProps}>
        {children}
      </button>
    );
  }

  return <li className={styles.listItem}>{item}</li>;
};

Dropdown.Item = DropdownItem;

export default Dropdown;
